import { Provider } from "react-redux"
import StoreProvider from "src/contexts"

import { store } from "src/redux/store"
import { ThemeStyledComponent } from "src/theme/ThemeStyledComponent"
import { ThemeProvider } from "styled-components"

const Providers = props => {
  return (
    <ThemeProvider theme={ThemeStyledComponent}>
      <Provider store={store}>
        <StoreProvider>{props.children}</StoreProvider>
      </Provider>
    </ThemeProvider>
  )
}
export default Providers
